var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"Preview","visible":_vm.preview,"width":"50%","top":"3vh","modal":true,"append-to-body":true,"custom-class":"preview-dialog"},on:{"close":function($event){return _vm.setPreview(false)}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.previewText)}}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }